@if(isVisible()){
<div class="udex-mb-32 udex-lg-mb-0" [id]="navLink.id">
  <h2 class="udex-grid udex-mx-auto heading__regular--l text-center udex-mb-32">
    {{ 'productDetails.plansAndPricing' | cxTranslate }}
  </h2>

  <dcp-plans-and-pricing-common-features [product]="product"></dcp-plans-and-pricing-common-features>

  @for (bundleTemplate of filteredBundleTemplates; track $index; let i = $index) {
  <div [class.d-none]="!i" class="d-sm-none udex-grid udex-mx-auto separator udex-my-32"></div>

  <dcp-plans-and-pricing-bundle-option [bundleTemplate]="bundleTemplate"></dcp-plans-and-pricing-bundle-option>
  }
</div>

<div class="udex-legacy-shadow d-none d-lg-block udex-my-32"></div>
}
